module.exports = __webpack_public_path__ + "img/1428132711.7facf55e.jpg";